import { useState } from 'react';

import { WithResponsiveProps } from '../utils/withResponsive';

import { GoldListItem } from './GoldListItem';

import { Paginator } from '@/components/Paginator';
import type { OtroFeoroTO } from '@/types/goldDate';
import { formatNumberToLocale } from '@/utils';

interface TournamentListProps extends WithResponsiveProps {
  title: string;
  subtitle?: string;
  items: OtroFeoroTO[];
  allItems?: OtroFeoroTO[];
  onPageChange?: (items: OtroFeoroTO[]) => void;
  prize?: number;
}

const itemsPerPage = 5;

export const GoldList = ({
  title,
  subtitle,
  items,
  allItems,
  onPageChange,
  prize,
  isDesktop,
  isMobile,
}: TournamentListProps) => {
  const formattedSubtitle =
    subtitle && prize
      ? subtitle.replace('$0', `$${formatNumberToLocale(prize)}`)
      : subtitle;

  const [currentPage, setCurrentPage] = useState(0);

  return (
    <>
      <div className="px-4 lg:mt-14 mt-6">
        <h1 className="text-black font-bold lg:text-2xl text-base">{title}</h1>
        {formattedSubtitle && (
          <p className="font-medium lg:font-semibold mt-2 text-sm text-gdt-gray-2">
            {formattedSubtitle}
          </p>
        )}
      </div>

      {isDesktop && (
        <div className="mt-6 lg:h-auto rounded-lg bg-white">
          {items.map((item: OtroFeoroTO, index: number) => {
            const globalIndex = currentPage * itemsPerPage + index + 1;
            return (
              <GoldListItem
                key={`${item.idTA}-${index}`}
                index={globalIndex}
                item={item}
              />
            );
          })}
          {allItems && allItems.length > 5 && onPageChange && (
            <Paginator
              currentContentPage={onPageChange}
              currentNumberPage={setCurrentPage}
              items={allItems}
              itemsPerPage={itemsPerPage}
            />
          )}
        </div>
      )}

      {isMobile && (
        <div className="mt-6">
          {(allItems || items).map((item: OtroFeoroTO, index: number) => (
            <GoldListItem
              key={`${item.idTA}-${index}`}
              index={index + 1}
              item={item}
            />
          ))}
        </div>
      )}
    </>
  );
};
